module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<style type="text/css" media="screen">\na.button.button-prod-more {\n	min-width: 75px;\n	text-align: center;\n	display: inline-block;\n	text-transform: uppercase;\n	font-weight: bold;\n	font-size: 14px;\n	padding: 5px 30px;\n	color: #fff !important;\n	background-color: #444;\n	cursor: pointer;\n	text-decoration: none;\n	margin-bottom: 10px;\n}\n</style>\n\n';
 if ( results && results.length > 0 ) { 
__p+='\n\n	';
 _.each( results, function(result) { 
__p+='\n\n	';
 if ( results.length > 1 ) { 
__p+='\n	<div class="class focus">\n		<h3>'+
((__t=( result.name ))==null?'':__t)+
'</h3>\n	</div>\n	';
 } 
__p+='\n\n\n	';
 if ( item && result.item_name  ) { 
__p+='\n\n		<div class="class focus">\n	\n			<div class="col images">\n				';
 if ( result.item_image ) { 
__p+='\n					<div class="image">\n						<div class="inner" style="background-image: url(//tramino.s3.amazonaws.com'+
((__t=( result.item_image ))==null?'':__t)+
')"></div>\n					</div>\n				';
 } else { 
__p+='\n					&nbsp;\n				';
 }  
__p+='\n			</div>\n\n			<div class="col info">\n\n				<h4>'+
((__t=( __('item_focused') ))==null?'':__t)+
'</h4>\n				<h2>'+
((__t=( result.item_name ))==null?'':__t)+
'</h2>\n				';
 if ( result.item_subheadline ) { 
__p+='<h6>'+
((__t=( result.item_subheadline ))==null?'':__t)+
'</h6>';
 } 
__p+='\n\n				';
 if ( result.item_info ) { 
__p+='\n					<div class="line">'+
((__t=( result.item_info.substr(0, 250) ))==null?'':__t)+
'</div>\n				';
 } 
__p+='\n\n				';
 if ( result.item_text ) { 
__p+='\n					<div class="line details details-1">'+
((__t=( result.item_text.substr(0, 1000).replace("\n","<br>") ))==null?'':__t)+
'</div>\n				';
 } 
__p+='\n\n				';
 console.log("---focus", result) 
__p+='\n\n				';
 if ( result.item_link ) { 
__p+='\n					<a class="button button-prod-more" href="'+
((__t=( item.link ))==null?'':__t)+
'" target="_blank" rel="noopener">\n						'+
((__t=( __('more_info') ))==null?'':__t)+
'\n					</a>\n\n				';
 } 
__p+='\n\n			</div>\n\n			<div class="col book">\n				<div class="inner">\n					<a href="" class="reset-item">&times;</a>\n				</div>\n			</div>\n\n			<div class="clear"></div>\n\n		</div>\n\n	';
 } 
__p+='\n\n	';

		var occupiedCount = 0;
		_.each(result.classes, function(item) {
			if ( item.occupied ) occupiedCount++
		});
		if ( result.classes.length == occupiedCount ) occupiedCount = 0; // wenn alles belegt
		if ( result.classes.length < 8 ) occupiedCount = 0; // kleinere Betriebe ausschliessen
	
__p+='\n\n	';
 _.each(result.classes, function(item) { 
__p+='\n\n	<div id="class_'+
((__t=( item.id ))==null?'':__t)+
'" class="class C'+
((__t=( result.client_id ))==null?'':__t)+
' '+
((__t=( item.occupied && occupiedCount > 3 ? 'item-occupied' : '' ))==null?'':__t)+
'" data-class="'+
((__t=( item.id ))==null?'':__t)+
'" '+
((__t=( item.occupied && occupiedCount > 3 ? 'style="display: none"' : '' ))==null?'':__t)+
'>\n\n		<div class="col images">\n			';
 if ( item.images ) { 
__p+='\n				<div class="slider">\n\n					';
 _.each( item.images.reverse(), function(img) { 
__p+='\n						<div class="slider_inner">\n							';
 var imgbig = img.replace("600x400", "1200") 
__p+='\n							<a href="//tramino.s3.amazonaws.com'+
((__t=( imgbig ))==null?'':__t)+
'" class=" fancybox image" title="'+
((__t=( item.name ))==null?'':__t)+
'" rel="r'+
((__t=( item.id ))==null?'':__t)+
'">\n								<div class="inner" style="background-image: url(//tramino.s3.amazonaws.com'+
((__t=( img ))==null?'':__t)+
')"></div>\n							</a>\n							';
 if ( item.images.length > 1 ) { 
__p+='\n								<div class="arrow prev"><div class="arrow-inner"></div></div>\n								<div class="arrow next"><div class="arrow-inner"></div></div>\n							';
 } 
__p+='\n						</div>				\n					';
 }) 
__p+='\n					\n				</div>\n			';
 } else if ( item.image ) { 
__p+='\n				<div class="image">\n					<div class="inner" style="background-image: url(//tramino.s3.amazonaws.com'+
((__t=( item.image ))==null?'':__t)+
')"></div>\n				</div>\n			';
 } else { 
__p+='\n				&nbsp;\n			';
 } 
__p+='\n			';
 if ( item.stars ) { 
__p+='\n			 	<div class="stars">'+
((__t=( __('result_validated') ))==null?'':__t)+
'<br/>'+
((__t=( item.stars ))==null?'':__t)+
'</div>\n			';
 } 
__p+='\n		</div>\n\n		<div class="col info">\n\n			';
 if ( item.subheadline ) { 
__p+='<h4>'+
((__t=( item.subheadline ))==null?'':__t)+
'</h4>';
 } 
__p+='\n			\n			<h2>'+
((__t=( item.name ))==null?'':__t)+
'</h2>\n			\n			<div class="line">\n\n				<div class="col text">\n					<div class="inner">\n						';
 if ( item.info ) { var s=item.info.substr( 0, 250); print(s); }
__p+='\n					</div>\n				</div>\n\n				<div class="col facts item-facts">\n					<div class="inner">'+
((__t=( item.facts ))==null?'':__t)+
'</div>\n				</div>\n\n				<div class="clear"></div>\n			</div>\n\n			<div class="line tags">\n				';
 _.each( item.tags, function( tag ) { 
__p+='\n					';
 if ( typeof tag == "string" ) { 
__p+='\n						<div class="tag">&#10003;&nbsp;&nbsp;&nbsp;'+
((__t=( tag ))==null?'':__t)+
'</div>\n					';
 } else { 
__p+='\n						<div class="tag">\n							&#10003;&nbsp;&nbsp;&nbsp;\n							<b>'+
((__t=( tag.name ))==null?'':__t)+
':</b>\n							'+
((__t=( tag.tags.join(", ") ))==null?'':__t)+
'\n						</div>\n					';
 } 
__p+='\n				';
 }) 
__p+='\n			</div>\n\n			';
 if ( item.text ) { 
__p+='\n				<div class="line details details-2">';
 var s=item.text.substr( 0, 1000); print(s); 
__p+='</div>\n			';
 } 
__p+='\n\n\n\n			';
 if ( item.packages ) { 
__p+='\n			<div class="subclasses" id="subclasses'+
((__t=( item.id ))==null?'':__t)+
'" style="display: block">\n				';
 _.each( item.packages, function(c) { 
__p+='			 \n					';
 if ( c.price ) { 
__p+='\n						<div class="subclass">\n							<div class="name">\n								'+
((__t=( c.name ))==null?'':__t)+
'\n								<div class="subclass-info">\n									'+
((__t=( c.subheadline ? c.subheadline.substr( 0, 140) : "" ))==null?'':__t)+
'\n\n									<a href="#reserva-package-'+
((__t=( c.id ))==null?'':__t)+
'" class="package-links">\n										&middot;&middot;&middot;\n									</a>\n								</div>\n							</div>\n							\n							<div class="subclass-price">\n								\n								';
 if ( c.discount_id ) { 
__p+='\n									<div class="subclass-discount">\n										<div class="subclass-discount-name">'+
((__t=( c.discount_name ))==null?'':__t)+
'</div>\n										<del>'+
((__t=( currencyHTML( c.discount_base, "EUR" ) ))==null?'':__t)+
'</del>\n										<div class="discount_popup"></div>\n										<div class="discount_details" style="display: none;">\n											'+
((__t=( c.discount_details ))==null?'':__t)+
'\n										</div>\n									</div>\n								';
 } 
__p+='\n\n								<div class="subclass-amount">'+
((__t=( currencyHTML( c.price, "EUR" ) ))==null?'':__t)+
'</div>\n\n								';
 if ( c.inkl ) { 
__p+='\n									<div class="subclass-facts">\n										';
 if ( c.inkl ) print("inkl. " + c.inkl) 
__p+='\n										';
 if ( item.show_spa_tax ) print( ", " + __('add_spa_tax') ) 
__p+=' \n									</div>\n								';
 } 
__p+='\n							</div>\n							<div class="subclass-action">\n								<div class="button-subclass button-booking button-booking-1"\n									 data-discount="'+
((__t=( c.discount_id ))==null?'':__t)+
'"\n									 data-item="'+
((__t=( c.id ))==null?'':__t)+
'"\n									 data-class="'+
((__t=( item.id ))==null?'':__t)+
'">\n									'+
((__t=( __('order') ))==null?'':__t)+
'\n								</div>\n							</div>\n							<div class="clear"></div>\n						</div>\n					';
 } 
__p+='\n				';
 }) 
__p+='\n\n				';
 if ( item.packages && item.packages.length > 0 ) { 
__p+='\n					<a href="#reserva-packages" class="button-more">'+
((__t=( __('more_offers') ))==null?'':__t)+
'</a>';
 } 
__p+='\n			</div><!-- /.subclasses -->\n			';
 } 
__p+=' \n\n\n		</div>\n\n		<div class="col book">\n			<div class="inner">\n	\n				';
 if ( item.price ) { 
__p+='\n\n					';
 if ( item.price_info ) { 
__p+='<div class="text">'+
((__t=( item.price_info  ))==null?'':__t)+
'</div>';
 } 
__p+='\n\n					<div class="price">\n							';
 if ( item.discount_id ) { 
__p+='\n								<div class="discount">\n									<div class="discount-name">'+
((__t=( item.discount_name ))==null?'':__t)+
'</div>\n									<del>'+
((__t=( currencyHTML( item.discount_base, "EUR" ) ))==null?'':__t)+
'</del>\n									';
 if ( item.discount_details ) { 
__p+='\n										<div class="discount_popup"></div>\n										<div class="discount_details" style="display: none;">\n											'+
((__t=( item.discount_details ))==null?'':__t)+
'\n										</div>\n									';
 } 
__p+='\n								</div>\n								\n							';
 } 
__p+='\n							'+
((__t=( currencyHTML( item.price, "EUR" ) ))==null?'':__t)+
'\n					</div>\n\n\n					';
 if ( result.booking ) { 
__p+='\n						';
 if ( registry('ResultView.ShowRequestButton') ) { 
__p+='\n						<div class="button button-request button-inquiry"\n							 data-discount="'+
((__t=( item.discount_id ))==null?'':__t)+
'"\n							 data-item="'+
((__t=( item.item ))==null?'':__t)+
'"\n							 data-class="'+
((__t=( item.id ))==null?'':__t)+
'">\n							'+
((__t=( __('inquiry') ))==null?'':__t)+
'\n						</div>\n						';
 } 
__p+='\n\n						<div class="button button-booking button-booking-2"\n							 data-discount="'+
((__t=( item.discount_id ))==null?'':__t)+
'"\n							 data-item="'+
((__t=( item.item ))==null?'':__t)+
'"\n							 data-class="'+
((__t=( item.id ))==null?'':__t)+
'">\n							 	'+
((__t=( __('order') ))==null?'':__t)+
'\n						</div>\n					';
 } else { 
__p+='\n						<div class="button button-request">'+
((__t=( __('inquiry') ))==null?'':__t)+
'</div>\n					';
 } 
__p+='\n\n					<div class="text">\n						';
 if ( item.item_name ) { 
__p+='<b>'+
((__t=( item.item_name ))==null?'':__t)+
'</b><br/>';
 } 
__p+='\n						'+
((__t=( __('total_price') ))==null?'':__t)+
' \n						';
 if ( item.inkl ) print( __('item_includes', { item: item.inkl} ) ) 
__p+=' \n						';
 if ( item.inkl && item.show_spa_tax ) print( __('add_spa_tax') ) 
__p+=' \n					</div>\n					\n					';
 if ( item.options ) { 
__p+='\n						<div class="booking-options">\n						';
 _.each( item.options, function( option ) { 
__p+='\n							<div class="booking-option">\n								'+
((__t=( option.name ))==null?'':__t)+
'\n								<select name="option_'+
((__t=( option.id ))==null?'':__t)+
'">\n								';
 _.each( option.classes, function( o ) { 
__p+='\n									<option value="'+
((__t=( o.id ))==null?'':__t)+
'">'+
((__t=( o.name ))==null?'':__t)+
' \n										';
 if ( o.inclusive ) { 
__p+='(inkl.)';
 } else { 
__p+='\n											'+
((__t=( o.price > 0 ? "+" : "" ))==null?'':__t)+
''+
((__t=( currencyHTML( o.price, "EUR" ) ))==null?'':__t)+
'\n									';
 } 
__p+='</option>\n								';
 }) 
__p+='\n								</select>\n							</div>\n						';
 }) 
__p+='\n						</div>\n					';
 } 
__p+='\n					\n\n				';
 } else { 
__p+='\n					<div class="price">\n						';
 if ( item.occupied ) { 
__p+='\n							<div class="missing">'+
((__t=( item.occupied ))==null?'':__t)+
'</div>\n						';
 } else { 
__p+='\n							<div class="missing">'+
((__t=( __('price_no_query') ))==null?'':__t)+
'</div>\n						';
 } 
__p+='\n					</div>\n					';
 if ( !item.occupied ) { 
__p+='\n						<div class="button button-more" onclick="miniEngine.setItem(\'\').then(miniEngine.app.showDatepicker); $(\'html, body\').animate({ scrollTop: $(\'#detail-booking\').offset().top}, 300);">\n							'+
((__t=( __('search') ))==null?'':__t)+
'\n						</div>\n					';
 } else { 
__p+='\n						<div class="button button-request">'+
((__t=( __('inquiry') ))==null?'':__t)+
'</div>\n					';
 } 
__p+='		\n				';
 } 
__p+='\n			</div>\n		</div>\n\n		<div class="clear"></div>\n\n\n		<button class="show-result-timetable" data-klass="'+
((__t=( item.id ))==null?'':__t)+
'" data-client="'+
((__t=( result.client_id ))==null?'':__t)+
'" data-for="#result-timetable-'+
((__t=( item.id ))==null?'':__t)+
'">'+
((__t=( __('occupancy_plan') ))==null?'':__t)+
'</button>\n		<div id="result-timetable-'+
((__t=( item.id ))==null?'':__t)+
'" class="class-timetable"></div>\n\n	</div>\n\n\n	';
 }) 
__p+='\n	\n\n	';
 if ( occupiedCount > 3 ) { 
__p+='\n\n		<div class="item-occupied-show-button" onclick="$(\'.item-occupied.C'+
((__t=( result.client_id ))==null?'':__t)+
'\').show(); $(this).hide();">\n			'+
((__t=( __("showUnavailableClasses", {occupiedCount: occupiedCount}) ))==null?'':__t)+
'\n		</div>\n\n	';
 } 
__p+='\n\n\n\n	';
 if ( result.packages && result.packages.length > 0 ) { 
__p+=' <h5 class="normal packages-title">'+
((__t=( __('packages') ))==null?'':__t)+
'</h5>';
 } 
__p+='\n	<div class="anker" id="reserva-packages"></div>\n\n	';
 _.each(result.packages, function(item) { 
__p+='\n\n	<div class="class package">\n		<div class="anker" id="reserva-package-'+
((__t=( item.id ))==null?'':__t)+
'"></div>\n		<div class="col images">\n			';
 if ( item.image ) { 
__p+='\n				<div class="image">\n					<div class="inner" style="background-image: url(//tramino.s3.amazonaws.com'+
((__t=( item.image ))==null?'':__t)+
')"></div>\n				</div>\n			';
 } else { 
__p+='\n				&nbsp;\n			';
 }  
__p+='\n		</div>\n\n		<div class="col info">\n\n			<h4>'+
((__t=( __('package') ))==null?'':__t)+
'</h4>\n			<h2>'+
((__t=( item.name ))==null?'':__t)+
'</h2>\n			';
 if ( item.subheadline ) { 
__p+='<h6>'+
((__t=( item.subheadline ))==null?'':__t)+
'</h6>';
 } 
__p+='\n\n			<div class="line">\n				<div class="col text">\n					<div class="inner">';
 if ( item.info ) { var s = item.info.substr( 0, 250 ); print(s); } 
__p+='</div>\n				</div>\n				<div class="col facts package-item-facts">\n					<div class="inner">'+
((__t=( item.facts.split(",").join("<br>") ))==null?'':__t)+
'</div>\n				</div>\n				<div class="clear"></div>\n			</div>\n\n			\n\n			<div class="subclasses" id="subclasses'+
((__t=( item.id ))==null?'':__t)+
'">\n				';
 _.each(item.classes, function(c) { 
__p+='\n					';
 if ( c.price ) { 
__p+='\n						<div class="subclass">\n							<div class="name">'+
((__t=( c.name ))==null?'':__t)+
'</div>\n							<div class="subclass-price">\n								<div class="subclass-amount">'+
((__t=( currencyHTML( c.price, "EUR" ) ))==null?'':__t)+
'</div>\n								';
 if ( c.facts ) { 
__p+='<div class="subclass-facts">'+
((__t=( c.facts ))==null?'':__t)+
'</div>';
 } 
__p+='\n							</div>\n							<div class="subclass-action">\n								<div class="button-subclass button-booking button-booking-3"\n									 data-item="'+
((__t=( item.id ))==null?'':__t)+
'"\n									 data-class="'+
((__t=( c.id ))==null?'':__t)+
'">\n									 	'+
((__t=( __('order') ))==null?'':__t)+
'\n								</div>\n							</div>\n							<div class="clear"></div>\n						</div>\n					';
 } 
__p+='\n				';
 }) 
__p+='\n			</div>\n\n			';
 if ( item.text ) { 
__p+='\n				<div class="line details details-3">';
 var s=item.text.substr( 0, 1000); print(s); 
__p+='</div>\n			';
 } 
__p+='\n\n			';
 if ( item.link ) { 
__p+='\n				<a class="button button-prod-more" href="'+
((__t=( item.link ))==null?'':__t)+
'" target="_blank" rel="noopener">\n					'+
((__t=( __('more_info') ))==null?'':__t)+
'\n				</a>\n			';
 } 
__p+='\n	\n		</div>\n\n		<div class="col book">\n			<div class="inner">\n				';
 if ( item.price_min ) { 
__p+='\n					<div class="price">\n						<span class="preis-ab">'+
((__t=( __('price_from') ))==null?'':__t)+
'</span>\n						'+
((__t=( currencyHTML( item.price_min, "EUR" ) ))==null?'':__t)+
'\n					</div>\n					<div class="button button-more" onclick="$(\'#subclasses'+
((__t=( item.id ))==null?'':__t)+
'\').slideDown(); $(this).fadeOut();">Mehr</div>\n					<div class="text">\n						'+
((__t=( __('total_price') ))==null?'':__t)+
' \n						';
 if ( item.inkl ) print( __('item_includes', { item: item.inkl} ) ) 
__p+=' \n						';
 if ( item.inkl && Tramino.client != 620 ) print( __('add_spa_tax') ) 
__p+=' \n					</div>\n				';
 } else { 
__p+='\n					<div class="price"><div class="missing">'+
((__t=( __('price_no_query') ))==null?'':__t)+
'</div></div>\n					<div class="button button-more" \n						onclick="miniEngine.setItem(\''+
((__t=( item.id ))==null?'':__t)+
'\').then(miniEngine.app.showDatepicker); miniEngine.search(); $(\'html,body\').animate({\'scrollTop\': 0})">'+
((__t=( __('search') ))==null?'':__t)+
'</div>\n				';
 } 
__p+='\n			</div>\n		</div>\n\n		<div class="clear"></div>\n	</div>\n\n\n	';
 }) /* end result.packages */ 
__p+='\n\n\n	';
 }) /* end results */ 
__p+='\n\n';
 } else if ( error ) { 
__p+='\n\n	<div class="notify results-404">\n		<h3>'+
((__t=( __('result_error_subtitle') ))==null?'':__t)+
'</h3>\n		'+
((__t=( error ))==null?'':__t)+
'\n	</div>\n\n';
 } else if ( isLoading ) { 
__p+='\n\n	<div class="notify results-loading">\n		<h3>'+
((__t=( __('loading_text') ))==null?'':__t)+
'</h3>\n	</div>\n\n';
 } else { 
__p+='\n\n	<div class="notify results-404">\n		<h3>'+
((__t=( __('results_404_title') ))==null?'':__t)+
'</h3>\n		'+
((__t=( __('results_404_prefix') ))==null?'':__t)+
'\n		 <a href="#" \n			onclick="miniEngine.app.formModel.set({ rooms: 0, select_mode: \'none\' })">'+
((__t=( __('results_404_link') ))==null?'':__t)+
'</a>\n	</div>\n\n';
 } 
__p+='\n';
}
return __p;
};


//////////////////
// WEBPACK FOOTER
// /Users/bm/app/code/jsapps/modules/reserva/templates/miniengine/classes-template.html
// module id = 74
// module chunks = 0